import React, { useCallback, useContext, useEffect, useMemo, useReducer, useState } from 'react'
import AuthroizedImages from '../ProductsComponents/AuthroizedImages';
import { Button } from 'primereact/button';
import { Tooltip, Zoom } from '@mui/material';
import { Loader } from '@aws-amplify/ui-react';
import { API } from 'aws-amplify';
import { deleteUserProductsCart, updateUserProductsCart } from '../../../Layout/MutaionsAndQueries';
import { AppContext } from '../../../Layout/Layout';
import { InputText } from 'primereact/inputtext';
import TruncateText from '../../../components/TruncateText';
import InventoryByProduct from '../ProductsComponents/InventoryByProduct';
import InventoryUI from '../ProductsComponents/ProductCommonUIs/InventoryUI';
import { FetchProductStock } from '../ProductsComponents/productCatalogAPI';
import PriceSection from '../ProductsComponents/PriceSection';
import UOMConversion from '../../../components/UOMConversion';
import { InputTextarea } from 'primereact/inputtextarea';
import getSymbolFromCurrency from 'currency-symbol-map';
import CurrencyFormat from '../../../components/CurrencyFormat';
import { RemoveProductFromCart, UpdateCartProductQty } from '../ProductsComponents/CartCUDFunctions';
import { showToast } from '../../../components/ToastUtils';
import CustomTooltip from '../../../components/CustomTooltip';
import ProductUnavailable from '../ProductsComponents/ProductCommonUIs/ProductUnavailable';
import { OutofStock } from '../ProductsComponents/ProductCommonUIs/OutofStock';


const ProductCardInitial = {
    PriceDetails: { Status: "Loading", ButtonStatus: "Loading" },
    QtyDetails: { Status: "Loading", ActStock: 9999, CurrentStock: 9999, UOM: "" },
    RestrictStatus: false
}
const ProductCardReducer = (state, action) => {
    switch (action.type) {
        case "PriceDetails":
            return { ...state, PriceDetails: action.payload }
        case "QtyDetails":
            return { ...state, QtyDetails: { ...state.QtyDetails, ...action.payload } }
        case "ReduceQty":
            return { ...state, QtyDetails: { ...state.QtyDetails, CurrentStock: state.QtyDetails.CurrentStock - action.payload } }
        case "RestrictProductStatus":
            return { ...state, RestrictStatus: action.payload }
        default:
            return state
    }

}


function ListCartProducts({ CartProduct, setPOBtnDisable, RestrictProductList, subTotalCalFn, setPriceChangeDialog }) {

    const [placeOrderCard, setPlaceorderCard] = useReducer(ProductCardReducer, ProductCardInitial);
    const { CartProductRelatedStates: { CartProductsList }, CartRelatedDispatch, Actions, taxDetails: { InventoryStatus } } = useContext(AppContext);
    const [count, setCount] = useState(CartProduct.ProductQuantity);
    const [remarkValue, setRemarkValue] = useState(CartProduct?.ProductRemarks || "");
    const [isProductValueUpdate, setisProductValueUpdate] = useState(false);
    const [removeBtnLoading, setRemoveBtnLoading] = useState(false);
    const CartProductRootDetails = CartProduct.Productdetails;

    const IFUnavaliable = placeOrderCard.PriceDetails.ButtonStatus === "Unavailable" || !CartProductRootDetails?.ProductActiveStatus;
    const IFNotUnavaliable = placeOrderCard.PriceDetails.ButtonStatus !== "Unavailable" && CartProductRootDetails?.ProductActiveStatus;

    const findProductUOMDetails = useCallback(() => {
        let productUOMs = JSON.parse(CartProductRootDetails.ProductQuantityDetails);
        // productUOMs = [{
        //     "unitCode": "EA",
        //     "CorrespondingQuantity": "1.00000000000000",
        //     "Quantity": "10",
        //     "CorrespondingQuantityTypeCode": "XBX",
        //     "id": 3
        // }]
        productUOMs = productUOMs.find((obj) => obj.CorrespondingQuantityTypeCode === CartProduct.ProductPriceUOMCode);
        if (productUOMs === undefined) {
            return { Quantity: 1 }
        }
        else {
            return productUOMs
        }


    },
        [CartProductRootDetails.ProductQuantityDetails],
    )

    const ProudctTotalAmt = useMemo(() => {
        if (placeOrderCard.PriceDetails.ButtonStatus !== "Unavailable") {
            if (placeOrderCard.PriceDetails?.DiscountPercentage) {
                if (placeOrderCard.PriceDetails.DiscountPercentage === 0) {
                    return CartProduct.ProductPrice * findProductUOMDetails().Quantity * count
                }
                else if (placeOrderCard.PriceDetails.DiscountPercentage > 0) {
                    const discountPercentage = Math.abs(parseFloat(placeOrderCard.PriceDetails.DiscountPercentage)) / 100;
                    const discountedPrice = parseFloat(CartProduct.ProductPrice) - discountPercentage * parseFloat(CartProduct.ProductPrice);

                    return discountedPrice * findProductUOMDetails().Quantity * count
                }

            }
            else {
                return CartProduct.ProductPrice * findProductUOMDetails().Quantity * count
            }
        }
        else if (placeOrderCard.PriceDetails.ButtonStatus === "Unavailable") {
            return 0;
        }

    }
        , [placeOrderCard.PriceDetails, CartProduct, count])

    useEffect(() => {
        if (placeOrderCard.QtyDetails.Status !== "Loading") {
            const FindSameProductStockReduce = CartProductsList.Data.filter(p => p.userProductsCartProductdetailsId === CartProduct.userProductsCartProductdetailsId);
            const TotalCartStockValue = FindSameProductStockReduce.reduce((a, b) => a + b.CalculatedUOMQuantity, 0);
            const FinalProductStock = parseInt((parseFloat(placeOrderCard.QtyDetails.ActStock) - TotalCartStockValue) / findProductUOMDetails().Quantity);

            setPlaceorderCard({
                type: "QtyDetails", payload: {
                    Status: placeOrderCard.QtyDetails.Status, ActStock: placeOrderCard.QtyDetails.ActStock,
                    CurrentStock: FinalProductStock > 0 ? FinalProductStock : 0,
                    UOM: placeOrderCard.QtyDetails.UOM
                }
            })
        }

    }, [CartProductsList])

    //When Inventory not available show Add to Cart button (Unlimited stock)
    useEffect(() => {
        if (!InventoryStatus) {
            setPlaceorderCard({ type: "QtyDetails", payload: { Status: "InStock", ActStock: 9999, CurrentStock: 9999, UOM: "" } })
        }
    }, [InventoryStatus])

    useEffect(() => {
        subTotalCalFn(CartProduct.id, ProudctTotalAmt, "Add");
    }, [ProudctTotalAmt, CartProduct.id]);

    useEffect(() => {
        if (RestrictProductList.Status === "Success") {
            if (RestrictProductList.Data.includes(CartProduct.userProductsCartProductdetailsId)) {
                setPlaceorderCard({ type: "RestrictProductStatus", payload: false });
                setPlaceorderCard({ type: "PriceDetails", payload: { Status: "ErrorPrice", ButtonStatus: "Unavailable" } });
                setPOBtnDisable((prev) => ({ ...prev, [CartProduct.userProductsCartProductdetailsId]: "Unavailable" }))
            }
            else {
                setPlaceorderCard({ type: "RestrictProductStatus", payload: true });
            }
        }
        else if (RestrictProductList.Status === "NoData") {
            setPlaceorderCard({ type: "RestrictProductStatus", payload: true });
        }

    }, [RestrictProductList.Status])

    useEffect(() => {
        if (placeOrderCard.PriceDetails.Status !== "Loading") {

            const DiscountPercentage = placeOrderCard?.PriceDetails?.DiscountPercentage === undefined ? 0 : placeOrderCard?.PriceDetails?.DiscountPercentage

            if (parseFloat(DiscountPercentage) !== CartProduct?.ProductDiscount && parseFloat(placeOrderCard.PriceDetails.ProductPrice) !== CartProduct?.ProductPrice) {
                UpdateAPIFn({ id: CartProduct.id, ProductDiscount: placeOrderCard.PriceDetails.DiscountPercentage, ProductPrice: placeOrderCard.PriceDetails.ProductPrice })
                setPriceChangeDialog(true);
            }
            else if (parseFloat(DiscountPercentage) !== CartProduct?.ProductDiscount) {
                UpdateAPIFn({ id: CartProduct.id, ProductDiscount: placeOrderCard.PriceDetails.DiscountPercentage });
                setPriceChangeDialog(true);
            }
            else if (parseFloat(placeOrderCard.PriceDetails.ProductPrice) !== CartProduct?.ProductPrice) {
                UpdateAPIFn({ id: CartProduct.id, ProductPrice: placeOrderCard.PriceDetails.ProductPrice });
                setPriceChangeDialog(true);
            }
            if (placeOrderCard.PriceDetails.ButtonStatus === "Unavailable") {
                setPOBtnDisable((prev) => ({ ...prev, [CartProduct.userProductsCartProductdetailsId]: "Unavailable" }))
            }

            setPOBtnDisable((prev) => {
                return Object.fromEntries(
                    Object.entries(prev).filter(([key]) => key !== "OnFocus")
                );
            });

        }
        else if (placeOrderCard.PriceDetails.Status === "Loading") {
            setPOBtnDisable((prev) => ({ ...prev, ["OnFocus"]: true }));
        }


        if (placeOrderCard.QtyDetails.Status === "OutOfStock") {
            setPOBtnDisable((prev) => ({ ...prev, [CartProduct.userProductsCartProductdetailsId]: "OutOfStock" }));
            setPOBtnDisable((prev) => {
                return Object.fromEntries(
                    Object.entries(prev).filter(([key]) => key !== "OnFocus")
                );
            });
        }
        else if (placeOrderCard.QtyDetails.Status === "Loading") {
            setPOBtnDisable((prev) => ({ ...prev, ["OnFocus"]: true }));
        }
        else if (placeOrderCard.QtyDetails.Status === "InStock") {
            setPOBtnDisable((prev) => {
                return Object.fromEntries(
                    Object.entries(prev).filter(([key]) => key !== "OnFocus")
                );
            });
        }

    }, [placeOrderCard])




    const alterQtyDetail = (params) => {
        if (CartProductRootDetails.ProductQuantityDetails === "[]") {
            const findProductUOM = findProductUOMDetails();
            // console.log("findProductUOM", findProductUOM)
            setPlaceorderCard({
                type: "QtyDetails", payload: {
                    ...params.payload,
                    CurrentStock: parseInt(params.payload.CurrentStock / parseFloat(findProductUOM.Quantity || 1)), UOM: CartProduct.ProductPriceUOMCode
                }
            })

        } else {
            setPlaceorderCard(params)
        }

    }

    const handleInputChange = (event) => {
        if (event.target.name === "productQty") {
            const enteredValue = event.target.value.trim();
            if (
                event.target.value === "" ||
                event.key === "Backspace" ||
                event.key === "Delete"
            ) {
                setCount("");
            } else {
                const numericValue = enteredValue.replace(/[^0-9]/g, "");
                const value = Number(numericValue);
                const FindSameProductStockReduce = CartProductsList.Data.filter(p => p.userProductsCartProductdetailsId === CartProduct.userProductsCartProductdetailsId);
                const TotalCartStockValue = FindSameProductStockReduce.reduce((a, b) => a + b.CalculatedUOMQuantity, 0);
                const FinalProductStock = parseInt((parseFloat(placeOrderCard.QtyDetails.ActStock) - TotalCartStockValue + CartProduct.CalculatedUOMQuantity) / findProductUOMDetails().Quantity);
                const newValue = Math.min(Math.max(value, 1), (FinalProductStock));
                setCount(newValue);
            }
        }
        else if (event.target.name === "Remarks") {
            setRemarkValue(event.target.value);
        }

    };

    const handleInputFocus = () => {
        setPOBtnDisable((prev) => ({ ...prev, ["OnFocus"]: true }));
    };

    const handleInputBlur = (event) => {
        // If input is left empty, set it to 1 on blur
        if (event.target.name === "productQty") {
            if (count === "") {
                setCount(1);

            }
        }

        handleSave(event);
        setPOBtnDisable((prev) => {

            return Object.fromEntries(
                Object.entries(prev).filter(([key]) => key !== "OnFocus")
            );
        });


    };

    const handleKeyPress = (event) => {

        if (event.key === "Enter") {
            handleSave(event);
        }
    };

    const handleSave = async (event) => {

        let CurrentAmountValue;
        if (event.target.name === "productQty") {
            setisProductValueUpdate(true);
            const savedValue = count === "" ? 1 : count;
            if (count === "") { setCount(1) }
            CurrentAmountValue = {
                id: CartProduct.id,
                CalculatedUOMQuantity: findProductUOMDetails().Quantity * savedValue, ProductQuantity: savedValue
            }
        }
        else if (event.target.name === "Remarks") {

            CurrentAmountValue = {
                id: CartProduct.id,
                ProductRemarks: remarkValue,
            };
        }
        UpdateAPIFn(CurrentAmountValue)
        setTimeout(() => {
            setisProductValueUpdate(false);
        }, 500);

    };

    const UpdateAPIFn = async (CurrentAmountValue) => {
        const UpdateCartProductQtyResponse = await UpdateCartProductQty(CurrentAmountValue)
        if (UpdateCartProductQtyResponse.Status === "Success") {
            CartRelatedDispatch({ type: Actions.CartProductQtyUpdate, payload: UpdateCartProductQtyResponse.Data });
        }
        else if (UpdateCartProductQtyResponse.Status === "Error") {
            showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
        }
    }


    const removeFromCart = async () => {
        setRemoveBtnLoading(true);
        const Removed = await RemoveProductFromCart({ CartProductID: CartProduct.id, CartRelatedDispatch, Actions });
        if (Removed) {
            subTotalCalFn(CartProduct.id, ProudctTotalAmt, "Remove");
            setPOBtnDisable((prev) => {
                if (!(CartProduct.userProductsCartProductdetailsId in prev)) {
                    return prev; // Return the same state if the key doesn't exist
                }

                return Object.fromEntries(
                    Object.entries(prev).filter(([key]) => key !== CartProduct.userProductsCartProductdetailsId)
                );
            });
        }
        setRemoveBtnLoading(false);

    }



    return (
        <>
            <div className='flex border-bottom-2 justify-content-center align-items-center '>

                <div className='col-3'>
                    <AuthroizedImages ProductImage={CartProductRootDetails ? CartProductRootDetails?.ProductImage : "https://customerportalproduct/public/noimageavalaible.png"}
                        imageStyle={{ height: "18vh", objectFit: "contain", borderRadius: "8px" }} />
                </div>

                <div className='col-3 flex flex-column gap-2 text-sm font-semibold text-blue-700'>
                    <TruncateText text={CartProduct.Productdetails.ProductName} maxLength={80} />
                    {(InventoryStatus && placeOrderCard.PriceDetails.ButtonStatus !== "Unavailable" && CartProductRootDetails?.ProductActiveStatus) && <InventoryByProduct setProductCardState={alterQtyDetail}
                        ProductCardState={placeOrderCard} ProductID={CartProduct.userProductsCartProductdetailsId} MainComponentFrom="PlaceOrder" />}
                </div>


                <div className={`${IFUnavaliable === "Unavailable" ? "col-3" : "col-2"} flex justify-content-end align-items-center`}>
                    {(placeOrderCard.RestrictStatus && CartProductRootDetails?.ProductActiveStatus) && <PriceSection ProductCardState={placeOrderCard} ProductID={CartProduct.userProductsCartProductdetailsId}
                        setProductCardState={setPlaceorderCard} priceClass="text-base " />}

                    {(IFUnavaliable) &&
                        <ProductUnavailable />
                    }

                </div>


                <div className={`${(IFUnavaliable === "Unavailable") ? "col-3" : "col-4"} flex flex-column justify-content-between gap-3`}>

                    {(IFNotUnavaliable && placeOrderCard.QtyDetails.Status === "InStock") &&
                        <div className='flex justify-content-between align-items-center'>
                            <div>
                                <CustomTooltip text="Press 'Enter' or 'Tab' to save the changes." placement='bottom'>
                                    <>
                                        {isProductValueUpdate && <div className='absolute text-center   z-10'
                                            style={{ backgroundColor: "rgba(251, 245, 245, 0.667)", width: "4%" }}>
                                            <Loader /></div>}
                                        <input
                                            type="text"
                                            value={count}
                                            style={{
                                                width: "55px",
                                                padding: "0px",
                                                borderBottom: "2px solid black",
                                                textAlign: "center",
                                                outline: "none"
                                            }}
                                            name='productQty'
                                            onChange={handleInputChange}
                                            onFocus={handleInputFocus}
                                            onBlur={handleInputBlur}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </>
                                </CustomTooltip>
                                <span className='text-xs capitalize'>
                                    (<UOMConversion UOMCode={CartProduct.ProductPriceUOMCode} />)
                                </span>
                            </div>

                            <div>
                                <InputTextarea placeholder='Remarks' value={remarkValue} name='Remarks' maxLength={200}
                                    onChange={handleInputChange}
                                    onFocus={handleInputFocus}
                                    onBlur={handleInputBlur}
                                    onKeyDown={handleKeyPress} />

                            </div>

                        </div>}


                    <div className='flex justify-content-between align-items-center'>
                        <div className=' flex gap-2 justify-content-start align-items-center' style={{ color: "var(--sidebar-color)" }}>
                            {(IFNotUnavaliable && placeOrderCard.QtyDetails.Status !== "OutOfStock") && <>
                                <span className='text-base '>Total Amount: </span>

                                <span className='text-lg font-semibold'>  {getSymbolFromCurrency(placeOrderCard.PriceDetails.ProductPriceCurrencyCode)}
                                    {CurrencyFormat(ProudctTotalAmt)}</span>
                            </>}

                            {
                                placeOrderCard.QtyDetails.Status === "OutOfStock" &&
                                <div className=''>
                                    <OutofStock />
                                </div>
                            }
                        </div>

                        <Button className="secondary-button " disabled={isProductValueUpdate}
                            onClick={removeFromCart} icon="pi pi-trash" loading={removeBtnLoading} />
                    </div>

                </div>


            </div>

        </>
    )
}

export default ListCartProducts